import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client/core';

const GET_SCHEDULER_DETAILS = gql`
  query SchedulerConfig {
    schedulerConfig {
      subscriptionExpiryDate
    }
  }
`;

export const useGetSchedulerDetails = () => {
  const { loading, error, data, refetch } = useQuery(GET_SCHEDULER_DETAILS, {
    context: { clientName: 'shop-api' },
  });

  return { loading, error, data, refetch };
};
